'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _moment = require('@alicd/next/lib/moment');

var _moment2 = _interopRequireDefault(_moment);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lib = require('@alicd/next/lib/_components/@alicd/next-util/lib');

var _commonMixin = require('@alicd/next/lib/_components/@alicd/next-time-picker/lib/view/common-mixin');

var _commonMixin2 = _interopRequireDefault(_commonMixin);

var _boundUtil = require('../boundUtil');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimePickerPanel = function (_Component) {
    (0, _inherits3.default)(TimePickerPanel, _Component);

    function TimePickerPanel(props, context) {
        (0, _classCallCheck3.default)(this, TimePickerPanel);

        var _this = (0, _possibleConstructorReturn3.default)(this, (TimePickerPanel.__proto__ || (0, _getPrototypeOf2.default)(TimePickerPanel)).call(this, props, context));

        _this.state = {
            value: props.value ? (0, _moment2.default)(props.value) : (0, _moment2.default)()
        };
        return _this;
    }

    (0, _createClass3.default)(TimePickerPanel, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.scrollToSelected(0);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            if ('value' in newProps) {
                this.setState({
                    value: newProps.value ? (0, _moment2.default)(newProps.value) : (0, _moment2.default)()
                });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.scrollToSelected(120);
        }
    }, {
        key: 'scrollToSelected',
        value: function scrollToSelected(duration) {
            var value = this.state.value;


            var hourDuration = 0,
                minuteDuration = 0,
                secondDuration = 0;

            if (this.currentSelectType === 'hour') {
                hourDuration = duration;
            } else if (this.currentSelectType === 'minute') {
                minuteDuration = duration;
            } else {
                secondDuration = duration;
            }

            if (this.hourSelect && this.hourList) {
                this.scrollTo(this.hourSelect, this.hourList.children[value.hour()].offsetTop, hourDuration);
            }

            if (this.minuteSelect && this.minuteList) {
                this.scrollTo(this.minuteSelect, this.minuteList.children[value.minute()].offsetTop, minuteDuration);
            }

            if (this.secondSelect && this.secondList) {
                this.scrollTo(this.secondSelect, this.secondList.children[value.second()].offsetTop, secondDuration);
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(key, nextValue) {
            var value = this.state.value;


            switch (key) {
                case 'hour':
                    value = (0, _moment2.default)(value).hour(nextValue);
                    break;
                case 'minute':
                    value = (0, _moment2.default)(value).minute(nextValue);
                    break;
                case 'second':
                    value = (0, _moment2.default)(value).second(nextValue);
                    break;
                default:
                    break;
            }
            this.currentSelectType = key;
            this.props.onChange(value);
        }
    }, {
        key: 'normalizeDisabledOptions',
        value: function normalizeDisabledOptions(options) {
            options = options && options instanceof Function ? options() : [];
            return options;
        }
    }, {
        key: 'renderPanel',
        value: function renderPanel(type, show) {
            var prefix = this.context.prefix || this.props.prefix;
            var value = this.state.value;


            var disabledOptions = this.normalizeDisabledOptions(this.props['disabled' + type.charAt(0).toUpperCase() + type.substr(1) + 's']);
            var count = type === 'hour' ? 24 : 60;
            var html = [];

            if (!show) {
                disabledOptions = [];
                for (var i = 0; i < count; i++) {
                    disabledOptions.push(i);
                }
            }

            for (var _i = 0; _i < count; _i++) {
                var _classNames;

                var bounds = null;
                if (this.props.altLowerBound || this.props.altUpperBound) {
                    var baseDate = (0, _moment2.default)(this.state.value).toDate();
                    baseDate.setHours(0, 0, 0, 0);
                    switch (type) {
                        case "second":
                            baseDate.setSeconds(_i);
                            baseDate.setMinutes(this.state.value.minute());
                            baseDate.setHours(this.state.value.hour());
                            break;
                        case "minute":
                            baseDate.setMinutes(_i);
                            baseDate.setHours(this.state.value.hour());
                            break;
                        case "hour":
                            baseDate.setHours(_i);
                            break;
                    }
                    bounds = (0, _boundUtil.getJudgeBound)(type, baseDate);
                }

                var disabledByAltBounds = bounds && (this.props.altLowerBound && this.props.altLowerBound > bounds.lower || this.props.altUpperBound && this.props.altUpperBound < bounds.upper);

                var cls = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, prefix + 'time-picker-cell-' + type, true), (0, _defineProperty3.default)(_classNames, prefix + 'time-picker-cell-selected', value[type]() === _i), (0, _defineProperty3.default)(_classNames, prefix + 'time-picker-cell-disabled', this.isInArray(_i, disabledOptions) || disabledByAltBounds), _classNames));
                var attrs = {
                    onClick: this.isInArray(_i, disabledOptions) || disabledByAltBounds ? null : this.onChange.bind(this, type, _i)
                };

                html.push(_react2.default.createElement(
                    'li',
                    (0, _extends3.default)({ className: cls }, attrs, { key: _i }),
                    _i
                ));
            }
            return html;
        }
    }, {
        key: '_setInstance',
        value: function _setInstance(name, ref) {
            this[name] = ref;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                showHour = _props.showHour,
                showMinute = _props.showMinute,
                showSecond = _props.showSecond,
                locale = _props.locale,
                others = (0, _objectWithoutProperties3.default)(_props, ['showHour', 'showMinute', 'showSecond', 'locale']);

            var prefix = this.context.prefix || this.props.prefix;

            return _react2.default.createElement(
                'div',
                (0, _extends3.default)({}, (0, _lib.pickAttrs)(others), { className: prefix + 'time-picker-panel' }),
                _react2.default.createElement(
                    'div',
                    { className: prefix + 'time-picker-panel-title' },
                    _react2.default.createElement(
                        'span',
                        { className: prefix + 'time-picker-panel-title-cell' },
                        locale.hour
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: prefix + 'time-picker-panel-title-cell' },
                        locale.minute
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: prefix + 'time-picker-panel-title-cell' },
                        locale.second
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: prefix + 'time-picker-panel-body' },
                    _react2.default.createElement(
                        'div',
                        { ref: this._setInstance.bind(this, 'hourSelect'), className: prefix + 'time-picker-select' },
                        _react2.default.createElement(
                            'ul',
                            { ref: this._setInstance.bind(this, 'hourList') },
                            this.renderPanel('hour', showHour)
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { ref: this._setInstance.bind(this, 'minuteSelect'), className: prefix + 'time-picker-select' },
                        _react2.default.createElement(
                            'ul',
                            { ref: this._setInstance.bind(this, 'minuteList') },
                            this.renderPanel('minute', showMinute)
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { ref: this._setInstance.bind(this, 'secondSelect'), className: prefix + 'time-picker-select' },
                        _react2.default.createElement(
                            'ul',
                            { ref: this._setInstance.bind(this, 'secondList') },
                            this.renderPanel('second', showSecond)
                        )
                    )
                )
            );
        }
    }]);
    return TimePickerPanel;
}(_react.Component);

TimePickerPanel.propTypes = {
    prefix: _propTypes2.default.string,
    value: _propTypes2.default.any,
    onChange: _propTypes2.default.func,
    showHour: _propTypes2.default.bool,
    showMinute: _propTypes2.default.bool,
    showSecond: _propTypes2.default.bool,
    disabledHours: _propTypes2.default.func,
    disabledMinutes: _propTypes2.default.func,
    disabledSeconds: _propTypes2.default.func,
    altLowerBound: _propTypes2.default.object,
    altUpperBound: _propTypes2.default.object
};
TimePickerPanel.defaultProps = {
    prefix: 'next-',
    locale: {},
    onChange: function onChange() {},
    showHour: true,
    showMinute: true,
    showSecond: true
};
TimePickerPanel.contextTypes = {
    prefix: _propTypes2.default.string
};
exports.default = TimePickerPanel;


(0, _commonMixin2.default)(TimePickerPanel);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-calendar-ex@0.0.4@@alicd/crui-calendar-ex/lib/view/time-picker-panel.js
// module id = 270
// module chunks = 0